import React from 'react';

import GroupReporting from "../../Reporting";

const AutoReportSettingsTabContent = () => {
  return (
    <GroupReporting isAutoReport isGroupReporting />
  )
};

export default AutoReportSettingsTabContent;